"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7985,107],{

/***/ 51469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 40046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Brand; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./src/uikit/Titles/H3.tsx
var H3 = __webpack_require__(89149);
// EXTERNAL MODULE: ./src/components/common/Carousel.tsx
var Carousel = __webpack_require__(71054);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/uikit/Links/Card.tsx
var Card = __webpack_require__(37026);
// EXTERNAL MODULE: ./src/utils/imageAlt.ts
var imageAlt = __webpack_require__(61254);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Brand/Brand.tsx








const Brand = _ref => {
  let {
    name,
    image,
    href,
    actionTitle
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
    w: "100%",
    h: "124px",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Card/* default */.Z, {
      href: href,
      title: actionTitle,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
        h: "5rem",
        w: "3rem",
        margin: "auto",
        pos: "relative",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: image,
          alt: (0,imageAlt/* getBrandLogoAlt */.fU)(name),
          layout: "fill",
          loading: "lazy"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
        align: "center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* LinkOverlay */.AB, {
          href: href,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
            fontFamily: "Montserrat-Medium",
            fontSize: ".75rem",
            textAlign: "center",
            color: "baseNeutral.600",
            letterSpacing: ".4px",
            children: name
          })
        })
      })]
    })
  });
};

/* harmony default export */ var Brand_Brand = (Brand);
;// CONCATENATED MODULE: ./src/components/Brand/index.tsx









const BrandsList = _ref => {
  let {
    title,
    brands
  } = _ref;
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  const isMobile = (0,index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
    pt: "xxl6",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Container */.W2, {
      as: dist_index_esm/* Stack */.Kq,
      maxW: "6xl",
      pb: "xxl6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(H3/* default */.Z, {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
        h: "300px",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel/* default */.Z, {
          grid: {
            rows: 2
          },
          slidesPerView: isMobile ? 2 : 7,
          spaceBetween: 28,
          withScrollbar: true,
          className: "home-carousel",
          children: brands.map(brand => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel/* default.Item */.Z.Item, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Brand_Brand, {
                name: brand.name,
                image: brand.image,
                href: `/noleggio-a-lungo-termine/${brand.href}`,
                actionTitle: t('indexPage:brands.actionTitle', {
                  brand: brand.name
                })
              })
            }, brand.name);
          })
        })
      })]
    })
  });
};

/* harmony default export */ var components_Brand = (BrandsList);

/***/ }),

/***/ 71054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export CarouselItem */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62852);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85278);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53918);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13390);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2416);
/* harmony import */ var swiper_css_grid__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_grid__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);












swiper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].use */ .ZP.use([swiper__WEBPACK_IMPORTED_MODULE_1__/* .Scrollbar */ .LW, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Navigation */ .W_, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Grid */ .rj]);
const Wrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].span.withConfig({
  componentId: "sc-1vzw1za-0"
})(["position:relative;display:", ";.swiper-grid-column{height:100%;}"], props => props.withCustomNavigation ? 'block' : 'inline');
/*
  workaround
  @see https://github.com/nolimits4web/swiper/issues/4413
  @see https://github.com/nolimits4web/swiper/issues/4084
*/

const Item = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
    children: children
  });
};

const CarouselItem = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/_jsx(SwiperSlide, {
    children: children
  });
};

const Carousel = _ref3 => {
  let {
    children,
    withScrollbar,
    withNavigation,
    withCustomNavigation,
    withPagination,
    slidesPerView,
    spaceBetween,
    className,
    breakpoints,
    grid
  } = _ref3;
  const {
    0: uniqueId,
    1: setUniqueId
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setUniqueId(`${Math.random()}`.substring(2, 15));
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(Wrapper, {
    className: className || '',
    withCustomNavigation: withCustomNavigation,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
      navigation: withCustomNavigation ? {
        nextEl: `.carousel-custom-next--${uniqueId}`,
        prevEl: `.carousel-custom-prev--${uniqueId}`
      } : withNavigation || false,
      pagination: withPagination ? {
        clickable: true
      } : false,
      scrollbar: withScrollbar ? {
        draggable: true,
        hide: false
      } : false,
      slidesPerView: slidesPerView || 'auto',
      spaceBetween: spaceBetween || 1,
      breakpoints: breakpoints,
      grid: grid,
      loopFillGroupWithBlank: true,
      children: [withCustomNavigation && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          className: `carousel-custom-next carousel-custom-next--${uniqueId}`
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          className: `carousel-custom-prev carousel-custom-prev--${uniqueId}`
        })]
      }), react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, child => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
        children: child
      }))]
    })
  });
};

Carousel.Item = Item;
/* harmony default export */ __webpack_exports__["Z"] = (Carousel);

/***/ }),

/***/ 37026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75159);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





const CardLink = _ref => {
  let {
    href,
    onClick,
    title,
    bg,
    children
  } = _ref;
  return href ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .LinkBox */ .fG, {
    title: title,
    borderRadius: 10,
    bg: bg || 'baseWhite',
    pb: "l",
    overflow: "hidden",
    borderColor: src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.colors.borders.grey */ .r.colors.borders.grey,
    borderWidth: 1,
    boxShadow: src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.shadows.cards */ .r.shadows.cards,
    _hover: {
      textDecoration: 'none',
      boxShadow: '0 4px 12px 0px rgba(65, 164, 118, 0.22)'
    },
    children: children
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
    title: title,
    onClick: onClick,
    cursor: "pointer",
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CardLink);

/***/ }),

/***/ 89149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const H3 = _ref => {
  let {
    children
  } = _ref,
      others = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, _objectSpread(_objectSpread({
    as: "h3",
    marginBottom: "xxl4",
    fontFamily: "Montserrat-SemiBold",
    fontSize: "1.75rem",
    lineHeight: "2.275rem"
  }, others), {}, {
    color: "baseDark",
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (H3);

/***/ }),

/***/ 73119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getFormattedMonthYear; },
/* harmony export */   "h": function() { return /* binding */ replaceDatePlaceholders; }
/* harmony export */ });
const currentDate = new Date();
const monthYear = currentDate.toLocaleString('it-IT', {
  month: 'long',
  year: 'numeric'
});
const formattedMonth = monthYear.charAt(0).toUpperCase() + monthYear.slice(1, -5);
const formattedYear = currentDate.getFullYear();
const getFormattedMonthYear = () => {
  return {
    formattedMonth,
    formattedYear
  };
};
const replaceDatePlaceholders = text => {
  if (!text) return null; // Fallback se il testo è null o undefined

  return text.replace('{{month}}', formattedMonth).replace('{{year}}', String(formattedYear));
};

/***/ }),

/***/ 61254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CY": function() { return /* binding */ getGalleryImagesAlt; },
/* harmony export */   "KX": function() { return /* binding */ getSellVehicleAltData; },
/* harmony export */   "NB": function() { return /* binding */ UNKNOWN_MAIN_VIEW; },
/* harmony export */   "Pr": function() { return /* binding */ getOfferCardAlt; },
/* harmony export */   "fU": function() { return /* binding */ getBrandLogoAlt; },
/* harmony export */   "k8": function() { return /* binding */ getVehicleImageAlt; }
/* harmony export */ });
/* unused harmony exports MAIN_IMAGE_VIEW, UNKNOWN_VIEW, getVehicleAltBase, getVehicleImageView */
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _dateUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73119);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/**
 * Attributo ALT delle immagini dei veicoli.
 *
 * Template richiesto per la foto principale di ogni offerta:
 *   {Brand} {Modello} {Versione} {Anno} – vista laterale sinistra
 *
 * Il template si applica quando lo scatto e' davvero una laterale sinistra.
 * Quando non lo e', l'alt dichiara l'angolazione reale ricavata dall'alt che
 * arriva da offers-explorer: descrivere un'inquadratura diversa da quella
 * mostrata vale meno di un alt generico, sia per chi usa uno screen reader sia
 * per la SEO. Sulle offerte di noleggio, ad esempio, la prima foto e' quasi
 * sempre un frontale e non una laterale sinistra.
 */

const MAIN_IMAGE_VIEW = 'vista laterale sinistra';
/** Prima foto con angolazione non ricavabile: e' comunque un esterno dell'auto. */

const UNKNOWN_MAIN_VIEW = 'vista esterna';
/** Foto successive alla prima con angolazione non ricavabile. */

const UNKNOWN_VIEW = 'altra vista';
const ALT_SEPARATOR = ' – ';

/**
 * Angolazioni riconosciute, dalla piu' specifica alla piu' generica:
 * l'ordine conta perche' "Anteriore Sinistra" deve vincere su "Anteriore".
 * Le stringhe che non descrivono un'inquadratura ("Vista Identificativa",
 * "Offerta auto {Modello}") non hanno una regola di proposito: devono cadere
 * sul fallback invece di far dichiarare un'angolazione inventata.
 */
const VIEW_RULES = [{
  pattern: /(anteriore|frontale|front)[\s-]*(sinistr\w*|sx)/i,
  view: 'vista tre quarti anteriore sinistra'
}, {
  pattern: /(anteriore|frontale|front)[\s-]*(destr\w*|dx)/i,
  view: 'vista tre quarti anteriore destra'
}, {
  pattern: /(posteriore|retro|rear)[\s-]*(sinistr\w*|sx)/i,
  view: 'vista tre quarti posteriore sinistra'
}, {
  pattern: /(posteriore|retro|rear)[\s-]*(destr\w*|dx)/i,
  view: 'vista tre quarti posteriore destra'
}, {
  pattern: /(laterale|fiancata|lato|side)[\s-]*(sinistr\w*|sx)/i,
  view: 'vista laterale sinistra'
}, {
  pattern: /(laterale|fiancata|lato|side)[\s-]*(destr\w*|dx)/i,
  view: 'vista laterale destra'
}, {
  pattern: /(obliqu\w*|tre quarti|3\/4)/i,
  view: 'vista tre quarti'
}, {
  pattern: /(interni|abitacolo|sedili)/i,
  view: 'vista interni'
}, {
  pattern: /(plancia|cruscotto|dashboard)/i,
  view: 'vista plancia e cruscotto'
}, {
  pattern: /(bagagliaio|baule|trunk)/i,
  view: 'vista bagagliaio'
}, {
  pattern: /(cerchi|cerchio|ruote|wheel)/i,
  view: 'dettaglio cerchi'
}, {
  pattern: /(anteriore|frontale|front)/i,
  view: 'vista frontale'
}, {
  pattern: /(posteriore|retro|rear)/i,
  view: 'vista posteriore'
}, {
  pattern: /(laterale|fiancata|side)/i,
  view: 'vista laterale'
}];

const squash = value => value.replace(/\s+/g, ' ').trim();
/**
 * "{Brand} {Modello} {Versione} {Anno}".
 * Le offerte di noleggio riguardano auto nuove e non espongono un anno di
 * immatricolazione, quindi si usa l'anno corrente, coerente con title e meta
 * description. Le offerte di vendita che valorizzano `year` usano il proprio.
 */


const getVehicleAltBase = function () {
  let {
    name,
    brand,
    model,
    version,
    year
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    formattedYear
  } = (0,_dateUtils__WEBPACK_IMPORTED_MODULE_1__/* .getFormattedMonthYear */ .P)();
  const vehicleName = name || `${brand || ''} ${model || ''}`;
  return squash([vehicleName, version, `${year || formattedYear}`].filter(Boolean).join(' '));
};
/**
 * Ricava l'angolazione dall'alt di origine, null se non e' riconoscibile.
 */

const getVehicleImageView = sourceAlt => {
  if (!sourceAlt) {
    return null;
  }

  const rule = VIEW_RULES.find(_ref => {
    let {
      pattern
    } = _ref;
    return pattern.test(sourceAlt);
  });
  return rule ? rule.view : null;
};
/**
 * Alt completo di una foto veicolo. `view` e' obbligatorio: va passata
 * l'angolazione reale dello scatto, non un default.
 */

const getVehicleImageAlt = (vehicle, view) => `${getVehicleAltBase(vehicle)}${ALT_SEPARATOR}${view}`;
/**
 * Alt per le card delle liste, dove l'angolazione spesso non e' nota: viene
 * aggiunta solo se ricavabile dall'alt di origine, altrimenti si resta sul
 * veicolo piu' il contesto (es. "noleggio a lungo termine").
 */

const getOfferCardAlt = (vehicle, context, sourceAlt) => {
  const base = squash(`${getVehicleAltBase(vehicle)} ${context}`);
  const view = getVehicleImageView(sourceAlt);
  return view ? `${base}${ALT_SEPARATOR}${view}` : base;
};
/**
 * Alt dei loghi di marca, unico punto in cui si compone la stringa "Logo ...".
 *
 * Va usata ovunque compaia un logo di marca - card marchi, titolo del PDP,
 * banner partnership, heading della privacy - cosi' la forma della stringa
 * resta una sola. Il `context` opzionale aggiunge la qualifica quando serve
 * distinguere il contesto (es. "Noleggio a Lungo Termine").
 */

const getBrandLogoAlt = (brand, context) => squash(`Logo ${brand || ''} ${context || ''}`);
/**
 * Dati anagrafici di un'offerta di vendita nella forma attesa dagli helper.
 * Il dettaglio espone brand/model/version sia sulla radice sia su `vehicle`,
 * che pero' e' opzionale e viene popolato solo se l'enrichment riesce.
 */

const getSellVehicleAltData = offer => {
  var _offer$vehicle, _offer$vehicle2, _offer$vehicle3, _offer$vehicle4;

  return {
    name: (_offer$vehicle = offer.vehicle) === null || _offer$vehicle === void 0 ? void 0 : _offer$vehicle.name,
    brand: ((_offer$vehicle2 = offer.vehicle) === null || _offer$vehicle2 === void 0 ? void 0 : _offer$vehicle2.brand) || offer.brand,
    model: ((_offer$vehicle3 = offer.vehicle) === null || _offer$vehicle3 === void 0 ? void 0 : _offer$vehicle3.model) || offer.model,
    version: ((_offer$vehicle4 = offer.vehicle) === null || _offer$vehicle4 === void 0 ? void 0 : _offer$vehicle4.version) || offer.version,
    year: offer.year
  };
};
/**
 * Riscrive gli alt di tutte le foto della gallery mantenendo l'angolazione
 * reale dello scatto. Eventuali collisioni vengono numerate per non avere due
 * alt identici nella stessa pagina.
 */

const getGalleryImagesAlt = (images, vehicle) => {
  if (!images || !images.length) {
    return [];
  }

  const usedAlts = [];
  return images.map((image, index) => {
    const view = getVehicleImageView(image.alt) || (index === 0 ? UNKNOWN_MAIN_VIEW : UNKNOWN_VIEW);
    const baseAlt = getVehicleImageAlt(vehicle, view);
    let alt = baseAlt;
    let occurrence = 1;

    while (usedAlts.indexOf(alt) !== -1) {
      occurrence += 1;
      alt = `${baseAlt} (${occurrence})`;
    }

    usedAlts.push(alt);
    return _objectSpread(_objectSpread({}, image), {}, {
      alt
    });
  });
};

/***/ }),

/***/ 55352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jj": function() { return /* binding */ getWindow; },
/* harmony export */   "Me": function() { return /* binding */ getDocument; }
/* harmony export */ });
/* unused harmony exports extend, ssrDocument, ssrWindow */
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */

/* eslint-disable no-param-reassign */
function isObject(obj) {
  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}

function extend() {
  let target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let src = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Object.keys(src).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      extend(target[key], src[key]);
    }
  });
}

const ssrDocument = {
  body: {},

  addEventListener() {},

  removeEventListener() {},

  activeElement: {
    blur() {},

    nodeName: ''
  },

  querySelector() {
    return null;
  },

  querySelectorAll() {
    return [];
  },

  getElementById() {
    return null;
  },

  createEvent() {
    return {
      initEvent() {}

    };
  },

  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},

      setAttribute() {},

      getElementsByTagName() {
        return [];
      }

    };
  },

  createElementNS() {
    return {};
  },

  importNode() {
    return null;
  },

  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};

function getDocument() {
  const doc = typeof document !== 'undefined' ? document : {};
  extend(doc, ssrDocument);
  return doc;
}

const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState() {},

    pushState() {},

    go() {},

    back() {}

  },
  CustomEvent: function CustomEvent() {
    return this;
  },

  addEventListener() {},

  removeEventListener() {},

  getComputedStyle() {
    return {
      getPropertyValue() {
        return '';
      }

    };
  },

  Image() {},

  Date() {},

  screen: {},

  setTimeout() {},

  clearTimeout() {},

  matchMedia() {
    return {};
  },

  requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }

    return setTimeout(callback, 0);
  },

  cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }

    clearTimeout(id);
  }

};

function getWindow() {
  const win =  true ? window : 0;
  extend(win, ssrWindow);
  return win;
}



/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);